
import Swiper from 'swiper';
import { Autoplay, EffectCoverflow, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Swiper.use([EffectCoverflow, Autoplay, Navigation, Pagination]);


const galeriaSwipers: (Swiper | null)[] = [null, null];
function initGaleriaSwipers() {
  [1, 2].forEach((idx) => {
    const galeria = document.querySelector<HTMLElement>(`.swiper-galeria-${idx}`);
    if (galeria) {
      if (galeriaSwipers[idx - 1]) {
        galeriaSwipers[idx - 1]?.destroy(true, true);
      }
      galeriaSwipers[idx - 1] = new Swiper(galeria, {
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 120,
          modifier: 2,
          slideShadows: true,
        },
        modules: [EffectCoverflow, Autoplay, Navigation, Pagination],
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // Tabs
  const tabButtons = document.querySelectorAll('.galeria-tab');
  const galeriaTabContents = document.querySelectorAll('.galeria-tab-content');
  tabButtons.forEach((btn, idx) => {
    btn.addEventListener('click', function (this: HTMLElement) {
      tabButtons.forEach(b => b.classList.remove('active', 'bg-anden-primary', 'text-white', 'z-2'));
      this.classList.add('active', 'bg-anden-primary', 'text-white', 'z-2');
      const target = this.getAttribute('data-galeria');
      galeriaTabContents.forEach((content, cidx) => {
        if (content.id === target) {
          content.classList.remove('hidden');
          // Destroy and re-init Swiper for this tab
          const galeria = content.querySelector<HTMLElement>(`.swiper-galeria-${cidx + 1}`);
          if (galeria) {
            galeriaSwipers[cidx]?.destroy(true, true);
            galeriaSwipers[cidx] = new Swiper(galeria, {
              effect: "coverflow",
              loop: true,
              grabCursor: true,
              centeredSlides: true,
              slidesPerView: "auto",
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
              coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 120,
                modifier: 2,
                slideShadows: true,
              },
              modules: [EffectCoverflow, Autoplay, Navigation, Pagination],
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
            });
          }
        } else {
          content.classList.add('hidden');
        }
      });
    });
  });
  initGaleriaSwipers();


  document.querySelectorAll('.swiper-button-next, .swiper-button-prev').forEach(btn => {
    btn.addEventListener('mousedown', e => e.preventDefault());
  });
});